import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/number/uint8/base/from-binary-string';
import __var_2__ from '@stdlib/number/uint8/base/to-binary-string';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace ns
*/
var ns = {};

/**
* @name fromBinaryStringUint8
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/uint8/base/from-binary-string}
*/
setReadOnly( ns, 'fromBinaryStringUint8', __var_1__);

/**
* @name toBinaryStringUint8
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/uint8/base/to-binary-string}
*/
setReadOnly( ns, 'toBinaryStringUint8', __var_2__);


// EXPORTS //
export default ns;

export { __var_1__ as fromBinaryStringUint8, __var_2__ as toBinaryStringUint8};